<template lang="pug">
#filtros-novo-monitoramento.view-container
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    placeholder='Pesquisa inteligente (Busque por CPF, CNPJ, CAR, ID da Pessoa, Munícipio, etc...)',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

        .filtros-avancados
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros Avançados

                el-form.filtro(label-position='top')
                    .filtros-avancados__cabecalho.mb-3
                        .filtros-avancados__titulo
                            b Filtros avançados
                        .filtros-avancados__aplicar-filtro(
                            @click='aplicarFiltros'
                        )
                            | Aplicar filtro

                    .filtros-avancados__collapse
                        el-form-item
                            el-select(
                                v-model='value',
                                class='',
                                placeholder='Selecione a categoria que deseja filtrar'
                            )
                                el-option(
                                    v-for='item in options',
                                    :key='item.value',
                                    :label='item.label',
                                    :value='item.value'
                                )

                            el-collapse(
                                v-model='activeNames',
                                @change='handleChange'
                            )
                                el-collapse-item(
                                    title='UF/Município',
                                    name='estados'
                                )
                                    .filtros-avancados__collapse--alinhamento
                                        el-select(
                                            v-model='value',
                                            class='',
                                            placeholder='Selecione um estado',
                                            size='large'
                                        )
                                            el-option(
                                                v-for='item in options',
                                                :key='item.value',
                                                :label='item.label',
                                                :value='item.value'
                                            )

                                        el-select(
                                            v-model='value',
                                            class='',
                                            placeholder='Selecione o município',
                                            size='large'
                                        )
                                            el-option(
                                                v-for='item in options',
                                                :key='item.value',
                                                :label='item.label',
                                                :value='item.value'
                                            )

                            el-collapse(
                                v-model='activeNames',
                                @change='handleChange'
                            )
                                el-collapse-item(title='Cooperativa', name='')

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados.mt-3
        span.filtros-selecionados__titulo Filtros selecionados:
        el-tag.filtros-selecionados__tags(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.filtros-selecionados__vazio(v-else) Nenhum filtro selecionado
</template>

<script>
import FomularioFiltroAvancadoMonitoramento from '@/components/monitoramento/FomularioFiltroAvancadoMonitoramento';

export default {
    name: 'FiltrarInteligenciaCarbono',
    props: {
        isMonitoramentoSocioambiental: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        FomularioFiltroAvancadoMonitoramento
    },
    data() {
        return {
            value: '',
            activeNames: '',
            options: [],
            pesquisa: '',
            opcoes: [],
            mostrarOpcoes: false,
            collapseFiltroAvancado: '',

            biomas: [],
            biomaSelecionado: '',
            estados: [],
            estadoSelecionado: '',
            municipios: [],
            municipioSelecionado: '',

            tags: [],
            resultadosSelecionados: [],

            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBiomas'
                },
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            }
        };
    },

    methods: {
        fecharLista() {
            setTimeout(() => {
                this.mostrarOpcoes = false;
            }, 300);
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);
            this.aplicarFiltros();
        },

        adicionarResultado(resultado) {},

        aplicarFiltros() {},

        abrirCollapse(collapse) {},

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {},

        buscarEstados() {},

        buscarMunicipios() {},

        exibirNotify(tipo, message) {},

        handleChange() {}
    }
};
</script>

<style lang="scss" scoped>
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.pesquisa-inteligente__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.pesquisa-inteligente__resultado {
    position: absolute;
    width: 100%;
}

.pesquisa-inteligente__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.pesquisa-inteligente__categoria {
    font-weight: bold;
}

.filtros-avancados__cabecalho {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filtros-avancados__aplicar-filtro {
    cursor: pointer;
    border: 1px solid #eeeeee;
    border-radius: 20px;
    padding: 4px 8px;
    color: var(--primary);
}

.filtros-avancados__collapse--alinhamento {
    display: flex;
    .el-select {
        margin-right: 3px;
    }
}

.pesquisa-inteligente-novo-monitoramento__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.el-collapse-item__biomas {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
}
.el-select {
    width: 100%;
}
</style>
